// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__10jAM","header":"Header_header__1WAEX"};